import { GET, POST, DELETE } from '../utils/http'

/** 根据活动状态查询文物鉴定活动列表信息 */
export const getActivityPageList = ({ pageNo = 1, pageSize = 5, activeStatus }) => GET('/shengbo/wechat/appraisal/activity/pageList', { pageNo, pageSize, activeStatus })

/** 根据主键id查询鉴定活动 */
export const getActivityQueryById = (id) => GET(`/shengbo/wechat/appraisal/activity/queryById?id=${id}`)

/** 根据活动id去获取活动状态 */
export const getActivityStatusById = (id) => GET(`/shengbo/wechat/appraisal/apply/activityStatistics?activityaId=${id}`)

/** 鉴定活动报名 */
export const applyAdd = (pramas) => POST('/shengbo/wechat/appraisal/apply/add', pramas)

/** 上传图片 */
export const Uploader = file => POST('/shengbo/wechat/sys/oss/file/upload', file, true)

/** 文物鉴定基本信息 */
export const getBasicOne = () => GET('/shengbo/wechat/appraisal/basic/one')

/** 精彩回顾富文本 */
export const getPbEducationHistoryId = id => GET('/shengbo/wechat/appraisal/basic/one', id)

/** 往期回顾 */
export const getHistoryList = ({ pageNo = 1, pageSize = 5 }) => GET('/shengbo/wechat/appraisal/history/list', { pageNo, pageSize })

/** 报名查询 */
export const querySignResultByPhone = ({ phone, activityId }) => GET('/shengbo/wechat/appraisal/apply/myRegistrationPage', { phone, activityId })
/** 活动取消 */
export const postActivities = applyId => DELETE(`/shengbo/wechat/appraisal/apply/cancelRegistration?id=${applyId}`)
